import { render, staticRenderFns } from "./new_cnab_remittance.vue?vue&type=template&id=29acf27e&scoped=true"
import script from "./new_cnab_remittance.vue?vue&type=script&lang=js"
export * from "./new_cnab_remittance.vue?vue&type=script&lang=js"
import style0 from "./new_cnab_remittance.vue?vue&type=style&index=0&id=29acf27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29acf27e",
  null
  
)

export default component.exports